import React, { useEffect } from "react";

import {
  Col,
  Button,
  Row,
  Container,
  Card,
  Form as FormBS,
} from "react-bootstrap";

import axios from "axios";

import PropagateLoader from "react-spinners/PropagateLoader";

import {
  useNavigate,
  Form,
  useActionData,
  useNavigation,
} from "react-router-dom";

const Login = ({ jwtHandler, jwt }) => {
  const navigate = useNavigate();
  const navigation = useNavigation();
  const actionData = useActionData();
  //const [submitting, setSubmitting] = useState(true);

  useEffect(() => {
    if (jwt) {
      navigate("/home");
    }
  }, [jwt, navigate]);

  return (
    <div>
      <Container>
        <Row className="mt-5 d-flex justify-content-center align-items-center">
          <Col md={8} lg={6} xs={12}>
            <Card className="shadow">
              <Card.Body>
                <h2 className="fw-bold mb-2 text-uppercase ">Login</h2>
                <div className="mb-3">
                  <Form method="post" action="/login">
                    {" "}
                    <FormBS.Group className="mb-3" controlId="formBasicEmail">
                      <FormBS.Label className="text-center">
                        Email address
                      </FormBS.Label>
                      <FormBS.Control
                        type="email"
                        placeholder="Enter email"
                        name="email"
                      />
                    </FormBS.Group>
                    <FormBS.Group
                      className="mb-3"
                      controlId="formBasicPassword"
                    >
                      <FormBS.Label>Password</FormBS.Label>
                      <FormBS.Control
                        type="password"
                        placeholder="Password"
                        name="password"
                      />
                    </FormBS.Group>
                    <div className="d-grid">
                      {actionData && actionData.status === "Failed" && (
                        <p style={{ textAlign: "center" }}>
                          {actionData.message}
                        </p>
                      )}
                      {actionData &&
                        actionData.status === "Success" &&
                        jwtHandler(actionData.jwt)}
                      {navigation.state === "submitting" && (
                        <>
                          <p style={{ textAlign: "center" }}>Signing in...</p>
                          <PropagateLoader
                            color={"#36d7b7"}
                            loading={true}
                            size={15}
                            cssOverride={{
                              height: 30,
                              marginLeft: "auto",
                              marginRight: "auto",
                            }}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                          />
                        </>
                      )}
                      <Button
                        variant="primary"
                        type="submit"
                        disabled={navigation.state === "submitting"}
                      >
                        Login
                      </Button>
                    </div>
                  </Form>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Login;

export async function action({ request, params }) {
  console.log("Login Action started");

  const formData = await request.formData();

  const email = formData.get("email").trim();
  const password = formData.get("password").trim();

  if (!email && !password) {
    return { status: "Failed", message: "Missing email and password" };
  }

  if (!email || email.length < 1) {
    return { status: "Failed", message: "Missing or empty email" };
  }

  if (!password || password.length < 1) {
    return { status: "Failed", message: "Missing or empty password" };
  }

  const postData = {
    email: email,
    password: password,
  };

  const response = await axios.post("/api/v1/login", postData, {
    headers: {
      "Content-Type": "application/json",
      apikey: "xxyyzz",
    },
  });

  if (response.status !== 200) {
    console.log("Login action not ok");
    //return { isError: true, message: "Error" };
  } else {
    console.log("Login action OK");
    const resData = response.data;
    console.log("Login action done");
    if (resData.status === "Success") {
      console.log("Login action API Successful");

      //     // store jwt
      //      localStorage.setItem("jwt", JSON.stringify(resData.jwt));

      return { status: "Success", jwt: resData.jwt };

      // Go to home page
      //      return redirect("/home");
    } else {
      console.log("Login action API Failed");
      return { status: "Failed", message: "Bad Login Request API" };
    }
  }

  console.log("Bad login");
  return { status: "failed", message: "Bad Login Request" };
}
